import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function MobileDeposit({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M10.6666 6.8234V5.33334H11.9999V18.6667H10.6666V17.1084C10.2757 17.008 9.90318 16.8758 9.56834 16.7154C8.88073 16.3861 8.15955 15.8416 8.01098 15.0364L9.32219 14.7945C9.34906 14.9401 9.54893 15.2278 10.1442 15.5129C10.3045 15.5896 10.4801 15.6593 10.6666 15.7204V12.4954C10.2031 12.3431 9.74806 12.1572 9.35469 11.9112C8.57562 11.4238 7.99992 10.6745 7.99992 9.52887C7.99992 8.61517 8.51514 7.91599 9.18362 7.45834C9.61364 7.16395 10.1257 6.95309 10.6666 6.8234ZM10.6666 8.20814C10.3887 8.29992 10.1409 8.41887 9.93683 8.55855C9.51979 8.84405 9.33325 9.17505 9.33325 9.52887C9.33325 10.1265 9.59088 10.4862 10.0618 10.7808C10.2404 10.8925 10.4431 10.9901 10.6666 11.0791V8.20814Z"
        fill={iconColor}
      />
      <Path
        d="M14.6609 16.8382C14.2611 17.0569 13.8056 17.1936 13.3333 17.2666V15.9116C13.5947 15.8559 13.8274 15.7743 14.021 15.6684C14.4322 15.4435 14.6666 15.1179 14.6666 14.5986C14.6666 14.3276 14.5981 14.1383 14.4963 13.9893C14.3889 13.832 14.2186 13.6828 13.9648 13.54C13.778 13.4349 13.5666 13.3437 13.3333 13.2598V11.856C13.7877 11.9956 14.234 12.1616 14.6184 12.3778C14.9895 12.5866 15.3402 12.8608 15.5973 13.2372C15.8601 13.6219 15.9999 14.0768 15.9999 14.5986C15.9999 15.6648 15.4448 16.4093 14.6609 16.8382Z"
        fill={iconColor}
      />
      <Path
        d="M13.3333 8.21097V6.82526C14.466 7.10317 15.5118 7.76811 15.9587 8.97902L14.7078 9.44065C14.4952 8.86457 13.9914 8.44434 13.3333 8.21097Z"
        fill={iconColor}
      />
      <Path
        d="M5.33325 4.66668C5.33325 2.82573 6.82564 1.33334 8.66659 1.33334H15.3333C17.1742 1.33334 18.6666 2.82573 18.6666 4.66668V19.3333C18.6666 21.1743 17.1742 22.6667 15.3333 22.6667H8.66659C6.82564 22.6667 5.33325 21.1743 5.33325 19.3333V4.66668ZM8.66659 2.66668C7.56202 2.66668 6.66659 3.56211 6.66659 4.66668V19.3333C6.66659 20.4379 7.56202 21.3333 8.66659 21.3333H15.3333C16.4378 21.3333 17.3333 20.4379 17.3333 19.3333V4.66668C17.3333 3.56211 16.4378 2.66668 15.3333 2.66668H8.66659Z"
        fill={iconColor}
      />
    </Svg>
  );
}
